export default "__VITE_ASSET__Drc9Xirm__"